// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorLayout_container__0kW83","image":"ErrorLayout_image__nMpr4","message":"ErrorLayout_message__lhnJS","title":"ErrorLayout_title__YcCey"};